import moment from 'moment';
import { initialize as initFn } from 'ldclient-js';
import { AuthTokenServiceModule } from 'services/auth/authToken.service';

export const LaunchDarklyServiceModule = angular
    .module('app.services.access.launchDarkly', [AuthTokenServiceModule])
    .service('launchDarklyService', ($q, $rootScope, authTokenService) => {
        let client;
        let initialized = false;
        let initDeferred = $q.defer();

        let service = {
            allFlags,
            getClient,
            getFeature,
            getLaunchDate,
            init,
            initialized,
            isNewAccount,
            isElementStore,
            unInit,
            updateUser,
            waitForInit,
            initFromToken
        };

        function updateUser(newUser) {
            return service.waitForInit().then(() => {
                let deferred = $q.defer();
                client.identify(newUser, null, () => {
                    deferred.resolve();
                });
                return deferred.promise;
            });
        }

        function init(user, initLD) {
            if (initialized) return $q.resolve();
            if (!initLD) return $q.reject();
            client = initLD(process.env.LAUNCH_DARKLY_KEY, user);
            client.on('ready', () => {
                initialized = true;
                initDeferred.resolve();
                $rootScope.$apply();
            });

            return initDeferred.promise;
        }

        function unInit() {
            initialized = false;
            initDeferred = $q.defer();
        }

        function getFeature(featureKey, defaultValue = false) {
            return service.waitForInit().then(() => {
                return client.variation(featureKey, defaultValue);
            }).catch(() => {
                return defaultValue;
            });
        }

        function getLaunchDate(featureKey, defaultValue = false) {
            return service.getFeature(featureKey, defaultValue).then((feature) => {
                let result = {
                    hasFeature: false,
                    hasMessaging: false
                };

                if (typeof feature === 'boolean') return feature;

                if (feature === 'off') return result;

                result.hasFeature = true;

                if (feature === 'cutover') return result;

                let [year, month, day] = feature.split(',').map(p => Number(p));
                let date = new Date(year, month - 1, day);
                let now = new Date();

                if (date.getTime() > now.getTime()) { // launch date not yet passed
                    result.hasMessaging = true;
                    result.launchDate = moment(date).format('MMMM D, YYYY');
                }

                return result;
            }).catch(() => {
                return defaultValue;
            });
        }

        function isNewAccount(storeInformation) {
            return service.getFeature('element-myvolusion-launch-date').then((elementLaunchDateFlag) => {
                if (!elementLaunchDateFlag) return false;

                const [year, month, day] = elementLaunchDateFlag.split(',').map(el => el.trim());
                const elementLaunchDate = new Date(year, month - 1, day);
                const storeCreatedOn = new Date(storeInformation.createdOn);

                return storeCreatedOn.getTime() >= elementLaunchDate.getTime();
            });
        }

        function isElementStore(storeInformationService) {
            return storeInformationService.getStore()
                .then(storeInformation => Promise.all([
                    service.getLaunchDate('element-launch'),
                    service.isNewAccount(storeInformation)
                ]))
                .then(([feature, newAccount]) =>
                    (feature.hasFeature && !feature.hasMessaging) || newAccount);
        }

        function allFlags() {
            return service.waitForInit().then(() => {
                return client.allFlags();
            });
        }

        function getClient() {
            return service.waitForInit().then(() => {
                return client;
            });
        }

        function waitForInit() {
            if (initialized) return $q.resolve();
            return initDeferred.promise;
        }

        function initFromToken(custom) {
            return authTokenService.getAccessToken().then(() => {
                const tenantPromise = authTokenService.getTenantId();
                const emailPromise = authTokenService.getEmail();
                return $q.all([tenantPromise, emailPromise]).then(([tenant, email]) => {
                    return service.init({
                        key: tenant,
                        email,
                        custom
                    }, initFn);
                });
            });
        }

        return service;
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/access/launchDarkly/launchDarkly.service.js